export default __webpack_public_path__ + "static/media/PlayIcon.6ec7bbca.svg";